// console.log('------------------', process.env);
// console.log(window.location.protocol, 'window.location.protocol')
export default {
  imgUrl: process.env.IMG_URL_QZ, // 图片线上地址
  apiUrl: process.env.APIURL,
  basePath: process.env.APIBASEPATH, // 测试分支打包 打开 路由路径前缀 master关闭
  masterRequestTest: process.env.APIURLQZ, // 请求前缀
  masterGoBackTest: process.env.GOBACKQZ, // 路由前缀
  isEncryptionDecryption: process.env.ISENCRYPTIONDECRYPTION, // 是否加解密
  appId: process.env.APPID,
  appToLink: process.env.APPTOLINK,
  // test: process.env.TEST,
  // apiUrl: 'https://ls.test.cqlanhui.com',
  // basePath: '', // master 路由路径前缀
  // masterRequestTest: '/face', // master请求
  // masterGoBackTest: '/', // master回退

  // apiUrl: 'https://ls2.test.cqlanhui.com',
  
  // imgUrl: 'https://34352n0e91.zicp.fun/', // 本地测试 威
  // apiUrl: 'http://3v7645s628.qicp.vip', // 本地测试用
  // basePath: '/test', // master 路由路径前缀
  // masterRequestTest: '/face-test', // master请求
  // masterGoBackTest: '/test/', // master回退

  // basePath: '/testysf', // 我是云闪付打开  测试
  // masterRequestTest: '/face-testysf', // 我是云闪付打开   测试
  // masterGoBackTest:'/testysf/', // 我是云闪付打开  测试

  siteName: '',
  minSiteMame: 'XNY',
  dfsPrefixPolicy: '',
  ossPrefix: '',
  timeout: 300000,
  cookiesExpires: 7,
  requestRetry: 4,
  requestRetryDelay: 1000
}



// WEBPACK FOOTER //
// ./src/config/config-1.js